module.exports = __webpack_public_path__ + "img/iPad-Landscape.4a346c37.png";